import { Chip } from '@mui/material'

const VersionChip = ({ version }: { version: string }) => {
  return (
    <Chip
      label={`v${version}`}
      size="small"
      sx={{
        height: 22,
        fontSize: 12,
        fontWeight: 700,
        fontFamily: 'monospace',
        // bgcolor: 'primary.main',
        color: 'primary.contrastText',
        border: '1px solid',
        borderColor: 'text.highlight',
      }}
    />
  )
}

export default VersionChip
